//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import {HeaderService} from '../../header.service';
import {TranslateService} from '@ngx-translate/core';
import {IRestConfig} from '../../../types/config';
import {Observable} from 'rxjs';
import {RestConfigService} from '../../../services/config-service';
import {IManageUser} from '../../../types/user';
import {Store} from '@ngrx/store';
import { OrgType } from 'src/types/group';
import authHelper from '../../auth/authHelper';
import {AppState} from '../../store/app.state';
import {selectUser} from '../../store/user/user.selectors';

@Component({
    selector: 'app-cryptography',
    templateUrl: './cryptography.component.html',
    styleUrls: ['./cryptography.component.scss'],
    standalone: false
})
export class CryptographyComponent implements OnInit {

  readonly OrgType = OrgType;
  restConfig$!: Observable<IRestConfig>;
  user$: Observable<IManageUser> = this.store.select(selectUser());
  encryptionEventViewer = authHelper.getFeatureFlagFromToken('eev');

  constructor(private readonly headerService: HeaderService,
              private readonly translate: TranslateService,
              private readonly restConfigService: RestConfigService,
              private readonly store: Store<AppState>,
  ) {
    this.headerService.setTitle(this.translate.instant('cryptography.title'));
    this.headerService.setSubtitle('');
    this.headerService.setIcon('mdi-zip-box-outline');
    this.headerService.setNavMenuText('');
  }

  ngOnInit(): void {
    this.restConfig$ = this.restConfigService.getRestConfig();
  }

}
